<template>
    <div class="lang-currency-country">
        <div class="selected-options">
            <p>
                <span class="d-sm-inline d-none">{{ langs[lang] }} /</span>
                <span :class="['iti-flag', lang_cls]"></span>
            </p>
        </div>
        <div class="selectors-popup">
            <form method="GET" @submit.prevent="submitForm">
                <Lang :lang="lang" :list="langs" @select="lang = $event" />
                <!-- <Timezone :timezones="zones" @select="timezone = $event" /> -->
                <!-- <Currency /> -->
                <button class="btn-primary-bg">{{ 'javascript.confirm' | trans }}</button>
            </form>
        </div>
    </div>
</template>

<script>
import Lang from './Lang'
// import Timezone from './Timezone'
// import Currency from './Currency'

export default {
  name: 'LocaleSettings',
  props: {
    url: String,
    params: Object,
    current: String,
    langs: Object,
    check: Boolean
  },

  data () {
    return {
      lang: '',
      timezone: null
    }
  },

  created () {
    this.lang = this.current
  },

  mounted () {
    if (this.check) {
      Echo.join('presence2')
        .here((users) => {
          // Log online users
        });
    }
  },

  computed: {
    lang_cls () {
      if (this.lang === 'en') return 'us'
      if (this.lang === 'da') return 'dk'
      return this.lang
    },
    zones () {
      return moment.tz.names()
    },
    routeUrl () {
      return `/language/${this.lang}/?route_name=${this.url}&route_params=${JSON.stringify(this.params)}&lang=${this.current}`
    }
  },

  methods: {
    submitForm () {
      window.location.replace(this.routeUrl)
    },
  },

  components: {
    Lang,
    // Timezone,
    // Currency
  }
}
</script>

<style lang="scss" scoped>
  .topmenu {
      .lang-currency-country {
          .selected-options {
              height: 100%;
              display: flex;
              cursor: pointer;

              p {
                  margin: 0;
                  align-self: center;
                  color: #fff;
              }

              .iti-flag {
                  display: inline-block;
                  margin: 0 5px;
              }
          }

          .selectors-popup {
              position: absolute;
              z-index: 3;
              display: none;
              max-width: 290px;
              background: #222f39;
              padding: 20px 20px 0;
              min-width: 220px;
              border-top: 2px solid #cd6215;

              &.active {
                  display: block;
              }
          }
      }
  }
</style>
